<template>
    <hr class="mb-5 border-dotted">
</template>

<script>
export default {}
</script>
